import { useEffect } from "react";
import { Header } from "./components/Header/Header";
import { Sidebar } from "./components/Sidebar/Sidebar";
import styles from "./layout.module.scss";
import { BUTTON_COLOR, PRIMARY_COLOR } from "../../constants/constants";

const Layout = ({ children }: any) => {
  useEffect(() => {
    const body = document.body;
    body.style.setProperty("--primary-color", PRIMARY_COLOR);
    body.style.setProperty("--button-color", BUTTON_COLOR);
  }, []);

  return (
    <div className={styles.layout}>
      <aside className={styles.aside}>
        <Sidebar />
      </aside>
      <header className={styles.header}>
        <Header />
      </header>
      <main className={styles.main}>{children}</main>
    </div>
  );
};

export default Layout;
